import { AuthStateInterface } from './../interfaces/authState';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { IUser } from './../interfaces/user';
import { ILoginResponse } from './../interfaces/loginResponse';
import axios, { AxiosResponse } from 'axios';
import environment from '@/environment';
import { ILoginCredentials } from './../interfaces/loginCredentials';
import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import store from '@/store';

export class AuthApi {
  public async login(
    credentials: ILoginCredentials,
    isImpersonate: string = 'false',
    rootEmail: string = '',
    userAccessToken: string = ''): Promise<ApiResponse<ILoginResponse>> {

    const bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'password');
    bodyFormData.append('client_id', environment.clientId);
    bodyFormData.append('client_secret', environment.clientSecret);
    bodyFormData.append('username', credentials.username);
    bodyFormData.append('password', credentials.password);
    bodyFormData.append('isImpersonate', isImpersonate);
    bodyFormData.append('rootEmail', rootEmail);
    bodyFormData.append('userAccessToken', userAccessToken);
    const response: AxiosResponse<ApiResponse<ILoginResponse>> = await axios.post(
      environment.backendUrl + environment.apiPrefix + '/account/login',
      bodyFormData,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );
    console.log('response', JSON.stringify(response, null, 2));
    return this.handleLoginResponse(response);
  }

  public async refreshToken(): Promise<ApiResponse<any>> {
    let token: string = '';
    if (store.state.auth && store.state.auth.refreshToken) {
      token = store.state.auth.refreshToken;
    }

    const bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'refresh_token');
    bodyFormData.append('client_id', environment.clientId);
    bodyFormData.append('client_secret', environment.clientSecret);
    bodyFormData.append('refresh_token', token);

    const response: AxiosResponse<ApiResponse<ILoginResponse>> = await axios.post(
      environment.backendUrl + environment.apiPrefix + '/account/login/refresh',
      bodyFormData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const apiResponse: ApiResponse<any> = response.data;

    if (apiResponse.success) {
      store.commit('auth/updateTokenData', {
        accessToken: apiResponse.data.access_token,
        refreshToken: apiResponse.data.refresh_token,
        tokenExpiresIn: apiResponse.data.expires_in,
      });
      this.updateLocalStorageData();
    }

    return apiResponse;
  }

  public async impersonate(email: string): Promise<ApiResponse<ILoginResponse>> {
    let user: null|AuthStateInterface = null;
    if (store.state.auth && store.state.auth.user) {
      user = store.state.auth;
    }

    // const bearer = user ? user.access_token : ''; // Correct AccessToken is from user not from API - todo
    const bearer = store.state.auth ? store.state.auth.accessToken : ''; // Temporary solution

    const response: AxiosResponse<ApiResponse<ILoginResponse>> = await axios.post(
      environment.backendUrl + environment.apiPrefix + '/account/impersonate',
      { email },
      {
        headers: {
          'Authorization': 'Bearer ' + bearer,
          'Content-Type': 'application/json',
        },
      },
    );

    return this.handleLoginResponse(response);
  }

  public async updateUser(user: IUser): Promise<boolean> {
    const response: AxiosResponse<ApiResponse<any>> = await AuthorizedApiClient.post('/profile', user);

    if (response) {
      const apiResponse = response.data;
      if (apiResponse.success) {
          // const updatedPayload = Object.assign(user, {
          //   personalDataFilled: apiResponse.data,
          // });
          // store.commit('auth/updateUser', updatedPayload);
          // this.updateLocalStorageData();
          return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  public async resetPassword(email: string): Promise<ApiResponse<any>> {
    const endpointUrl =
      environment.backendUrl +
      environment.apiPrefix +
      '/account/password-reset';

    const response: AxiosResponse<ApiResponse<any>> = await AuthorizedApiClient.post(endpointUrl, {email});
    return response.data;
  }

  public async setNewPassword(formData: { password: string; repeatPassword: string }): Promise<ApiResponse<any>> {
    const endpointUrl =
      environment.backendUrl +
      environment.apiPrefix +
      '/account/password-reset/change';

    const response = await AuthorizedApiClient.post(endpointUrl, formData);
    return response.data;
  }

  public async invokePasswordReset(payload: { email?: string; brokerId?: number }): Promise<ApiResponse<any>> {
    const response: AxiosResponse<ApiResponse<any>> =
      await AuthorizedApiClient.post('/account/password-reset-invoke', payload);
    return response.data;
  }

  public updateLocalStorageData(): void {
    console.log('updating local storage', store.state.auth);
    localStorage.setItem(
      environment.authLocalStorageKey,
      JSON.stringify(store.state.auth),
    );
  }

  protected handleLoginResponse(response: AxiosResponse<ApiResponse<ILoginResponse>>) {
    const apiResponse: ApiResponse<ILoginResponse> = response.data;

    if (response.status === 200) {
      if (apiResponse.success) {
        const data = apiResponse.data;
        data.user.loginDate = (new Date()).getTime();
        store.commit('auth/updateUser', data.user);
        store.commit('auth/updateTokenData', {
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
          tokenExpiresIn: data.expires_in,
        });
        this.updateLocalStorageData();
      }
    }

    // Preserve error_code from backend response for better error handling
    return apiResponse;
  }
}
